//外部依赖
import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
// 图标
import FavoriteIcon from '@/assets/icons/favoriteIcon.svg';
import WishIconProduct from '@/assets/icons/WishIconProduct.svg';
// 接口和ts
import { BizType, followApi, unFollowApi } from '@/apis/dp/service';
import type { productData_5 } from '../../index.interface';
import { ProductState } from '../../index.interface';
//内部组件和方法
import CDNImage from '@/components/cdnImage/cdnImage';
import JDIPrice from '@/components/price/index';
import SafeLink from '@/components/SafeLink';
import UKLoadingIcon, { CIRCLE_COLOR_MAP, SIZE_MAP } from '@/components/UKLoadingIcon';
import UKProductSelDrawer from '@/components/UKProductSelDrawer';
import UKToast from '@/components/UKToast/index';
import { safeJsonParse } from '@/utils';
import { addCartUtil, CartResProps } from '@/utils/cartUtils';
import { formatProductLink } from '@/utils/formatProductLink';
import OutOfStackController from '@/utils/outofStock/outofStockController';
import { comparePrice, formatStyle, getExptag, imgTipsStyle } from '../../common/utils';
//多语言
import { useTranslation } from '@/i18n/client';
//样式
import style from './style.module.scss';
import { useStores } from '@/models';

interface PropsType {
  productData: productData_5;
}

export default function ProductCard_5({ productData }: PropsType) {
  const {
    width,
    height,
    skuName,
    skuNameStyle,
    skuImgKeyParams,
    skuImg,
    skuImgStyle,
    skuImgProps,
    skuId,
    realPrice,
    realPriceJDIPriceParams,
    originalPrice,
    originalPriceJDIPriceParams,
    currency,
    languageCode,
    imgTips,
    shouldShowCart,
    onClickCart,
    onAddCartSuccess,
    shouldShowModal = true,
    shouldShowService = false,
    jumpTarget,
    jumpUrl,
    onClickProduct,
    marketingStyle_2,
    marketingArray_2 = [],
    promotions,
    priceStyle,
    trackingPointParams,
    subscribeType,
    subscribeStatus,
    NotifyCallback,
    isWish,
    productState,
    viewedTip,
    brandName,
    addCartOtherParams = {},
    originalPriceTips,
  } = productData;

  let { containerStyle } = productData;
  //兼容传入宽高的样式
  containerStyle = Object.assign({}, containerStyle);
  if (width !== undefined && width !== null) {
    containerStyle.width = formatStyle(width);
  }
  if (height !== undefined && height !== null) {
    containerStyle.height = formatStyle(height);
  }
  
  //到手价默认样式
  const defaultRealPriceJDIPriceParams = {
    symbolStyle: { fontSize: '14px' },
    integerStyle: { fontSize: '20px' },
    decimalPointStyle: { fontSize: '20px' },
    decimalPlaceStyle: { fontSize: '20px' },
    containerStyle: {
      display: 'block',
      height: '20px',
      lineHeight: '20px',
      fontWeight: 700,
      color:
        productState === ProductState.REMOVED
          ? '#1A1A1A'
          : originalPrice && comparePrice(originalPrice, realPrice)
            ? '#CC0C1C'
            : realPriceJDIPriceParams?.containerStyle?.color,
    },
  };

  //划线价默认样式
  const defaultOriginalPriceJDIPriceParams = {
    symbolStyle: { fontSize: '14px' },
    integerStyle: { fontSize: '16px' },
    decimalPointStyle: { fontSize: '16px' },
    decimalPlaceStyle: { fontSize: '16px' },
    containerStyle: {
      display: 'block',
      height: '20px',
      lineHeight: '20px',
      fontWeight: 700,
      color: '#1A1A1A',
    },
  };

  const { t } = useTranslation();
  const { cartNumStore } = useStores();
  const router = useRouter();
  const [isShowProductModal, setIsShowProductModal] = useState(false); // 是否显示选择商品类型弹窗
  const [notifyStatus, setNotifyStatus] = useState(subscribeStatus);
  const [btnLoading, setBtnLoading] = useState(false); //加车和订阅按钮loading
  const [isWished, setIsWished] = useState(isWish || false); //是否添加心愿单
  const [wishLoading, setWishLoading] = useState(false); //心愿单loading
  const [group_1, setGroup_1] = useState<any[]>([...marketingArray_2]); //type=1是底部

  //处理营销标签富文本
  const getPromotions = () => {
    const group_1: any[] = [];
    promotions?.map((promotion) => {
      promotion = expandShowStyle(promotion);
      if (promotion.type === 1) {
        const dom = (
          <span
            dangerouslySetInnerHTML={{ __html: promotion.richText }}
            key={promotion.text}
          ></span>
        );
        group_1.push(dom);
      }
    });
    setGroup_1(group_1);
  };

  //处理营销标签富文本
  function expandShowStyle(obj: any) {
    const showStyleObj = safeJsonParse(obj?.showStyle, {});
    return { ...obj, ...showStyleObj };
  }

  //点击商卡事件
  const handleProductClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    if (trackingPointParams && trackingPointParams.productClickPoint) {
      trackingPointParams.productClickPoint();
    }
    // 检查 onClickProduct 是否存在并且是一个函数
    if (onClickProduct && typeof onClickProduct === 'function') {
      onClickProduct(productData);
    } else {
      //如果不加这个setTimeout的话，上面的埋点和sgm就没法全都执行
      if (jumpUrl) {
        setTimeout(() => {
          window.location.href = jumpUrl;
        }, 100);
      } else {
        router.push(formatProductLink(skuId, skuName));
      }
    }
  };

  //点击购物车事件
  const handleCartClick = (e: any, productData: productData_5) => {
    e.preventDefault();
    e.stopPropagation();
    if (trackingPointParams && trackingPointParams.cartClickPoint) {
      trackingPointParams.cartClickPoint();
    }
    //无货下架不能加车
    if (btnLoading || productState !== ProductState.IN_STOCK) {
      return;
    }
    // 检查 onClickCart 是否存在并且是一个函数
    if (onClickCart && typeof onClickCart === 'function') {
      onClickCart(productData);
    } else {
      //加车时是否展示规格弹层
      if (shouldShowModal) {
        setIsShowProductModal(true);
      } else {
        //直接加车
        loadAddCart({ skuId });
      }
    }
  };

  //调用加车方法
  const loadAddCart = ({ skuId }: any) => {
    addCartUtil({
      productList: [{ skuId, num: '1' }],
      otherParams: { ...addCartOtherParams },
    }).then((res: CartResProps) => {
      if (trackingPointParams && trackingPointParams.addCartPoint) {
        trackingPointParams.addCartPoint();
      }
      if (res?.result?.code === '200') {
        // 更新购物车数量
        cartNumStore.updateCartNum(res?.result?.data);
      }
      //加车接口调用成功回调方法
      if (onAddCartSuccess && typeof onAddCartSuccess === 'function') onAddCartSuccess(productData);
    });
  };

  //关闭规格弹窗
  const handleClose = () => {
    setIsShowProductModal(false);
  };
  //点击订阅按钮
  const handleNotify = (e: any, skuId: string) => {
    e.preventDefault();
    e.stopPropagation();
    if (btnLoading || notifyStatus !== 0) {
      return;
    }
    setBtnLoading(true);
    const skuIds = [skuId];
    OutOfStackController.getInstance().openOutOfStockDialog(skuIds, notifySuccess, notifyFail);
  };
  //订阅成功回调
  const notifySuccess = () => {
    setBtnLoading(false);
    NotifyCallback && NotifyCallback(true);
    setNotifyStatus(1);
  };
  //订阅失败回调
  const notifyFail = () => {
    setBtnLoading(false);
    NotifyCallback && NotifyCallback(false);
  };
  //点击心愿单事件
  const handleClickWish = async (e: any) => {
    e.stopPropagation();
    if (wishLoading) {
      return;
    }
    //点击收藏埋点
    if (trackingPointParams && trackingPointParams.wishClickPoint) {
      trackingPointParams?.wishClickPoint(isWished ? '2' : '1');
    }
    setWishLoading(true);
    //判断当前是否添加心愿单
    if (isWished) {
      const res = await unFollowApi({ bizIds: skuId, bizType: BizType.PRODUCT });
      if (res?.code === '200') {
        setIsWished(false);
      } else {
        UKToast.show({
          content: res?.msg || t('common.message.systemError'), // 弹窗内容
          icon: 'error', // 可选：success, fail, loading, warn, info，影响图标
        });
      }
    } else {
      const res = await followApi({ bizIds: skuId, bizType: BizType.PRODUCT });
      if (res?.code === '200') {
        setIsWished(true);
      } else {
        UKToast.show({
          content: res?.msg || t('common.message.systemError'), // 弹窗内容
          icon: 'error', // 可选：success, fail, loading, warn, info，影响图标
        });
      }
    }
    setWishLoading(false);
  };

  useEffect(() => {
    if (promotions && promotions.length > 0) {
      getPromotions();
    }
  }, [promotions]);

  return (
    <div
      className={`${style.UK_product_card} ${style[productState]}`}
      style={containerStyle}
      key={skuId}
      exptag={getExptag('exptag', trackingPointParams, 'productExpConfig')}
      data-exptag-config={getExptag('config', trackingPointParams, 'productExpConfig')}
      data-exptag-json-param={getExptag('json-param', trackingPointParams, 'productExpConfig')}
      data-exptag-event-param={getExptag('event-param', trackingPointParams, 'productExpConfig')}
    >
      <SafeLink
        href={jumpUrl ? jumpUrl : formatProductLink(skuId, skuName)}
        target={jumpTarget}
        onClick={handleProductClick}
      >
        {/* 商品图片 */}
        <div className={style.UK_image_wrapper}>
          <CDNImage
            {...skuImgProps}
            style={skuImgStyle}
            className={`${style.UK_skuImg} ${
              productState !== ProductState.IN_STOCK ? style.op50 : ''
            }`}
            src={(skuImgKeyParams ? skuImgKeyParams?.imgUrlKey : skuImg) as string}
            width={skuImgKeyParams?.width || 240}
            height={skuImgKeyParams?.height || 240}
            alt={skuName}
          />
          {/* 商品图片背景及hover遮罩 */}
          <div className={style.UK_mask}></div>
          {imgTips && imgTips.tipDom ? (
            <span className={style.UK_imgTips} style={imgTipsStyle(imgTips.position)}>
              {imgTips.tipDom}
            </span>
          ) : null}
        </div>
      </SafeLink>

      {/* 加车按钮楼层 */}
      {shouldShowCart && (
        <div className={style.UK_AddCart_wrapper}>
          {
            // 缺货订阅按钮
            subscribeType === 0 ? (
              <button
                className={`${notifyStatus === 0 ? style.UK_Notify : style.UK_Notify_hidden}`}
                onClick={(e) => handleNotify(e, skuId)}
              >
                {btnLoading ? (
                  <UKLoadingIcon className={style.UK_btnLoading} type={CIRCLE_COLOR_MAP.BLACK} />
                ) : (
                  t(`${notifyStatus === 0 ? 'outofstock.NotifyMe' : 'outofstock.WellNotifyYou'}`)
                )}
              </button>
            ) : (
              // 加车按钮
              <button
                className={`${style.UK_AddCart} ${
                  productState !== ProductState.IN_STOCK ? style.UK_unAddCart : ''
                }`}
                onClick={(e: any) => handleCartClick(e, productData)}
                exptag={getExptag('exptag', trackingPointParams, 'cartExpConfig')}
                data-exptag-config={getExptag('config', trackingPointParams, 'cartExpConfig')}
                data-exptag-json-param={getExptag(
                  'json-param',
                  trackingPointParams,
                  'cartExpConfig',
                )}
                data-exptag-event-param={getExptag(
                  'event-param',
                  trackingPointParams,
                  'cartExpConfig',
                )}
              >
                {t('cart.addCart')}
              </button>
            )
          }
          <button
            className={style.UK_WishIcon_wrap}
            onClick={handleClickWish}
            exptag={getExptag('exptag', trackingPointParams, 'wishExpConfig')}
            data-exptag-config={getExptag('config', trackingPointParams, 'wishExpConfig')}
            data-exptag-json-param={getExptag('json-param', trackingPointParams, 'wishExpConfig')}
            data-exptag-event-param={getExptag('event-param', trackingPointParams, 'wishExpConfig')}
          >
            {wishLoading ? (
              <UKLoadingIcon
                className={style.UK_WishLoading}
                type={CIRCLE_COLOR_MAP.BLACK}
                size={SIZE_MAP.SIZE_24}
              />
            ) : isWished ? (
              <FavoriteIcon className={style.UK_FavoriteIcon} width={18} height={18} />
            ) : (
              <WishIconProduct className={style.UK_WishIcon} width={18} height={18} />
            )}
          </button>
        </div>
      )}
      {viewedTip && <div className={style.UK_viewedTip}>{viewedTip}</div>}
      <SafeLink
        href={jumpUrl ? jumpUrl : formatProductLink(skuId, skuName)}
        target={jumpTarget}
        onClick={handleProductClick}
      >
        {/* 商品名称 */}
        <div className={style.UK_name_wrapper} style={skuNameStyle}>
          <div className={style.UK_name_box}>
            {/* 品牌营销标签 */}
            {brandName && (
              <span className={style.UK_brandName}>
                <span className={style.UK_brandName_text}>{brandName}</span>
                <span className={style.UK_brandName_line}></span>
              </span>
            )}
            {/* 商品标签 */}
            <span className={style.UK_name}>{skuName}</span>
          </div>
        </div>

        {/* 商品价格+ 营销标签 */}
        <div className={style.UK_price_wrapper} style={priceStyle}>
          <div className={style.UK_price}>
            {/* 优惠价格 */}
            <div className={style.UK_realPrice}>
              <JDIPrice
                locale={languageCode}
                currency={currency || ''}
                price={realPrice}
                uiType={1}
                {...defaultRealPriceJDIPriceParams}
                {...realPriceJDIPriceParams}
              />
            </div>
            {/* 划线价 */}
            {originalPrice && comparePrice(originalPrice, realPrice) && (
              <div className={style.UK_originalPrice}>
                {originalPriceTips ? (
                  <span className={style.UK_originalPriceTips}>{originalPriceTips}</span>
                ) : null}
                <JDIPrice
                  locale={languageCode}
                  currency={currency || ''}
                  price={originalPrice}
                  uiType={2}
                  lineThrough
                  {...defaultOriginalPriceJDIPriceParams}
                  {...originalPriceJDIPriceParams}
                />
              </div>
            )}
          </div>
        </div>

        {/* 底部营销标签 */}
        {group_1.length > 0
          ? group_1.map((item: JSX.Element, i: number) => {
              return (
                <div className={style.UK_activityRow} key={i} style={marketingStyle_2}>
                  {item}
                </div>
              );
            })
          : null}

        {/* 无货和下架文案 */}
        {productState !== ProductState.IN_STOCK && (
          <div className={style.UK_OutOfStockText}>
            {t(
              productState === ProductState.OUT_OF_STICK
                ? 'common.productStatus.outOfStock'
                : productState === ProductState.REMOVED
                  ? 'common.productStatus.removed'
                  : '',
            )}
          </div>
        )}
      </SafeLink>
      <UKProductSelDrawer
        skuId={String(skuId)}
        triggerOpen={isShowProductModal}
        handleClose={handleClose}
        updateItemData={loadAddCart}
        isShowService={shouldShowService}
      />
    </div>
  );
}
